(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fi-hero-reel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fi-hero-reel')) {
    class FiHeroReel extends HTMLElement {
      connectedCallback() {
        this.scenes = [...this.querySelectorAll('[data-scene]')];
        this.dots = [...this.querySelectorAll('[data-go]')];
        this.lookSlot = this.querySelector('[data-look-slot]');
        this.pauseBtn = this.querySelector('[data-pause]');
        this.interval = Number(this.dataset.interval) || 7000;
        this.index = 0;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const conn = navigator.connection;
        this.lite = this.reduced || (conn && (conn.saveData || /2g/.test(conn.effectiveType || '')));
        this.userPaused = false;
        this.hoverPaused = false;
        this.inView = true;

        this.dots.forEach((dot) =>
          dot.addEventListener('click', () => {
            this.show(Number(dot.dataset.go));
            this.restart();
          })
        );
        this.pauseBtn?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.classList.toggle('is-user-paused', this.userPaused);
          this.pauseBtn.setAttribute('aria-label', this.userPaused ? 'Play scenes' : 'Pause scenes');
          this.sync();
        });
        const rail = this.querySelector('.fi-reel__rail');
        rail?.addEventListener('pointerenter', () => { this.hoverPaused = true; this.sync(); });
        rail?.addEventListener('pointerleave', () => { this.hoverPaused = false; this.sync(); });
        this.addEventListener('focusin', (e) => {
          if (e.target.matches?.(':focus-visible')) { this.hoverPaused = true; this.sync(); }
        });
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) { this.hoverPaused = false; this.sync(); }
        });
        this.io = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          this.sync();
        }, { threshold: 0.2 });
        this.io.observe(this);
        document.addEventListener('visibilitychange', () => this.sync());

        if (this.reduced) {
          this.userPaused = true;
          this.classList.add('is-user-paused');
          this.pauseBtn?.setAttribute('hidden', '');
        }
        this.show(0);
        this.sync();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.io?.disconnect();
      }

      get running() {
        return !this.userPaused && !this.hoverPaused && this.inView && !document.hidden && this.scenes.length > 1;
      }

      show(i) {
        this.index = (i + this.scenes.length) % this.scenes.length;
        this.scenes.forEach((scene, n) => {
          const on = n === this.index;
          scene.classList.toggle('is-active', on);
          scene.toggleAttribute('aria-hidden', !on);
          const v = scene.querySelector('video');
          if (!v) return;
          if (on && !this.lite) this.play(v);
          else v.pause();
        });
        this.dots.forEach((dot, n) => {
          dot.classList.toggle('is-active', n === this.index);
          if (n === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        const tpl = this.scenes[this.index].querySelector('template[data-look]');
        if (this.lookSlot) this.lookSlot.replaceChildren(tpl ? tpl.content.cloneNode(true) : '');
        const next = this.scenes[(this.index + 1) % this.scenes.length];
        next?.querySelector('img')?.setAttribute('loading', 'eager');
        // The next scene's video is no longer pre-downloaded (saved ~1.6 MB on first load); its poster shows
        // until play() attaches the source when that scene becomes active.
        this.restartFill();
      }

      play(v) {
        if (!v.src) v.src = (innerWidth < 750 && v.dataset.srcM) || v.dataset.src;
        if (!this.inView || document.hidden) return;
        const p = v.play();
        const mark = () => v.classList.add('is-playing');
        if (v.readyState >= 3) mark(); else v.addEventListener('playing', mark, { once: true });
        p?.catch(() => {});
      }

      restartFill() {
        const fill = this.dots[this.index]?.querySelector('.fi-reel__dot-fill');
        if (!fill) return;
        fill.style.animation = 'none';
        void fill.offsetWidth;
        fill.style.animation = '';
      }

      restart() {
        clearTimeout(this.timer);
        this.started = 0;
        this.remaining = this.interval;
        this.sync();
      }

      sync() {
        const run = this.running;
        this.classList.toggle('is-running', !this.reduced && this.scenes.length > 1);
        this.classList.toggle('is-paused', !run);
        const v = this.scenes[this.index]?.querySelector('video');
        if (v && !this.lite) {
          if (this.inView && !document.hidden) this.play(v); else v.pause();
        }
        clearTimeout(this.timer);
        if (this.remaining == null) this.remaining = this.interval;
        if (this.started) {
          this.remaining = Math.max(400, this.remaining - (Date.now() - this.started));
          this.started = 0;
        }
        if (!run) return;
        this.started = Date.now();
        this.timer = setTimeout(() => {
          this.remaining = this.interval;
          this.started = 0;
          this.show(this.index + 1);
          this.sync();
        }, this.remaining);
      }
    }
    customElements.define('fi-hero-reel', FiHeroReel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fi-scroll-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fi-scroll-film')) {
    class FiScrollFilm extends HTMLElement {
      connectedCallback() {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const conn = navigator.connection;
        this.clips = [...this.querySelectorAll('.fi-sf__clip')];
        this.beats = [...this.querySelectorAll('.fi-sf__beat')];
        this.mobile = window.innerWidth < 750;
        if (reduced || (conn && conn.saveData) || !this.clips.length) {
          this.classList.add('is-static');
          return;
        }
        this.now = this.querySelector('.fi-sf__now');
        this.fill = this.querySelector('.fi-sf__fill');
        this.track = this.querySelector('.fi-sf__track');
        this.active = 0;
        this.shown = [];
        this.load(0); this.load(1);
        this.onScroll = () => this.measure();
        document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.io = new IntersectionObserver(([e]) => {
          this.visible = e.isIntersecting;
          if (this.visible) this.tick();
        });
        this.io.observe(this);
        this.measure();
        window.__fiFilmReady = true;
      }
      disconnectedCallback() {
        document.removeEventListener('scroll', this.onScroll, { capture: true });
        window.removeEventListener('resize', this.onScroll);
        this.io?.disconnect();
      }
      load(i) {
        const v = this.clips[i];
        if (!v || v.dataset.loaded) return;
        v.dataset.loaded = '1';
        v.preload = 'auto';
        v.src = (this.mobile && v.dataset.srcM) || v.dataset.src;
        v.load();
      }
      measure() {
        const r = this.track.getBoundingClientRect();
        const span = r.height - window.innerHeight;
        const p = Math.min(1, Math.max(0, -r.top / (span || 1)));
        const n = this.clips.length;
        const pos = p * n;
        let i = Math.min(n - 1, Math.floor(pos));
        const local = i === n - 1 && p >= 1 ? 1 : pos - i;
        this.target = { i, local };
        this.fill.style.transform = 'scaleX(' + p.toFixed(4) + ')';
        this.classList.toggle('is-end', p > 0.96);
        if (!this.raf && this.visible) this.tick();
      }
      tick() {
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          if (!this.target) return;
          const { i, local } = this.target;
          if (i !== this.active) {
            this.load(i); this.load(i + 1);
            this.clips[this.active].classList.remove('is-on');
            this.clips[i].classList.add('is-on');
            this.active = i;
            this.now.textContent = String(i + 1).padStart(2, '0');
            this.beats.forEach((b) => b.classList.toggle('is-on', Number(b.dataset.i) === i));
          }
          const v = this.clips[i];
          if (v.readyState >= 1 && v.duration) {
            const want = Math.min(v.duration - 0.04, local * v.duration);
            const cur = v.currentTime;
            const next = cur + (want - cur) * 0.22;
            if (Math.abs(want - cur) > 0.015 && !v.seeking) v.currentTime = next;
            if (Math.abs(want - cur) > 0.015 && this.visible) this.tick();
          } else if (this.visible) {
            this.tick();
          }
        });
      }
    }
    customElements.define('fi-scroll-film', FiScrollFilm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fi-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fi-shop-the-look')) {
    class FiShopTheLook extends HTMLElement {
      connectedCallback() {
        if (this._ac) return;
        this._ac = new AbortController();
        const opts = { signal: this._ac.signal };
        this.items = [...this.querySelectorAll('[data-item]')].map((el) => this.setupItem(el, opts));
        this.querySelectorAll('[data-spot]').forEach((dot) => {
          dot.addEventListener('click', () => this.toggleSpot(dot), opts);
        });
        document.addEventListener('click', (e) => {
          if (!e.target.closest || !e.target.closest('.fi-stl__spot')) this.closeSpots();
        }, opts);
        this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeSpots(true); }, opts);
        this.querySelector('[data-add-all]')?.addEventListener('click', (e) => this.addAll(e.currentTarget), opts);
        this.updateTotal();
      }

      disconnectedCallback() {
        this._ac?.abort();
        this._ac = null;
      }

      setupItem(el, opts) {
        let variants = [];
        try { variants = JSON.parse(el.querySelector('[data-variants]')?.textContent || '[]'); } catch (_) {}
        const item = {
          el,
          variants,
          name: el.querySelector('.fi-stl__name')?.textContent.trim() || '',
          selects: [...el.querySelectorAll('[data-opt]')],
          input: el.querySelector('[data-variant]'),
          price: el.querySelector('[data-price]'),
          msg: el.querySelector('[data-msg]'),
          add: el.querySelector('[data-add]'),
          variant: null,
        };
        item.selects.forEach((sel) => sel.addEventListener('change', () => {
          sel.classList.remove('is-missing');
          item.msg.textContent = '';
          this.resolve(item);
          this.updateTotal();
        }, opts));
        item.add?.addEventListener('click', () => this.addItems([item], item.add), opts);
        this.resolve(item);
        return item;
      }

      resolve(item) {
        if (!item.variants.length) return;
        if (!item.selects.length) {
          item.variant = item.variants[0];
        } else {
          const picked = item.selects.map((s) => s.value);
          if (picked.some((v) => v === '')) {
            item.variant = null;
            const pool = item.variants.filter((v) => picked.every((p, i) => p === '' || v.options[i] === p));
            const cheapest = pool.reduce((m, v) => (m && m.price <= v.price ? m : v), null);
            if (cheapest) item.price.textContent = this.money(cheapest.price);
            if (item.add) item.add.disabled = !pool.some((v) => v.available);
            return;
          }
          item.variant = item.variants.find((v) => v.options.every((o, i) => o === picked[i])) || null;
        }
        if (item.variant) {
          item.input.value = item.variant.id;
          item.price.textContent = this.money(item.variant.price);
          if (item.add) item.add.disabled = !item.variant.available;
          if (!item.variant.available) item.msg.textContent = 'Sold out in this option';
        } else if (item.add) {
          item.add.disabled = true;
          item.msg.textContent = 'Not available in this combination';
        }
      }

      basePrice(item) {
        if (item.variant) return item.variant.price;
        const picked = item.selects.map((s) => s.value);
        const pool = item.variants.filter((v) => picked.every((p, i) => p === '' || v.options[i] === p));
        return pool.length ? Math.min(...pool.map((v) => v.price)) : 0;
      }

      updateTotal() {
        const total = this.items.reduce((sum, it) => sum + this.basePrice(it), 0);
        const out = this.querySelector('[data-total]');
        if (out) out.textContent = this.money(total);
        const ship = this.querySelector('[data-ship]');
        if (ship) ship.hidden = total < Number(ship.dataset.threshold || 0);
      }

      missing(item) {
        const sel = item.selects.find((s) => s.dataset.required && s.value === '');
        return sel || null;
      }

      toggleSpot(dot) {
        const open = dot.getAttribute('aria-expanded') !== 'true';
        this.closeSpots();
        if (!open) return;
        dot.setAttribute('aria-expanded', 'true');
        const tip = document.getElementById(dot.getAttribute('aria-controls'));
        if (tip) tip.hidden = false;
        const row = this.querySelector(`[data-item="${dot.dataset.spot}"]`);
        if (row) {
          row.classList.add('is-active');
          const r = row.getBoundingClientRect();
          if (r.top < 0 || r.bottom > window.innerHeight) {
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            row.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
          }
        }
      }

      closeSpots(refocus) {
        this.querySelectorAll('[data-spot][aria-expanded="true"]').forEach((d) => {
          d.setAttribute('aria-expanded', 'false');
          const tip = document.getElementById(d.getAttribute('aria-controls'));
          if (tip) tip.hidden = true;
          if (refocus) d.focus();
        });
        this.querySelectorAll('.fi-stl__item.is-active').forEach((r) => r.classList.remove('is-active'));
      }

      addAll(button) {
        const ready = this.items.filter((it) => it.variants.length);
        const blocked = ready.filter((it) => this.missing(it));
        if (blocked.length) {
          blocked.forEach((it) => {
            const sel = this.missing(it);
            sel.classList.add('is-missing');
            it.msg.textContent = `Pick a ${sel.dataset.required.toLowerCase()}`;
          });
          this.status(`Pick a size for ${blocked.map((b) => b.name).join(' and ')} first.`, true);
          this.missing(blocked[0])?.focus();
          return;
        }
        const buyable = ready.filter((it) => it.variant && it.variant.available);
        if (!buyable.length) return;
        this.addItems(buyable, button);
      }

      async addItems(items, button) {
        for (const it of items) {
          const sel = this.missing(it);
          if (sel) {
            sel.classList.add('is-missing');
            it.msg.textContent = `Pick a ${sel.dataset.required.toLowerCase()}`;
            sel.focus();
            return;
          }
        }
        const lines = items.filter((it) => it.variant).map((it) => ({ id: it.variant.id, quantity: 1 }));
        if (!lines.length) return;
        button.disabled = true;
        this.status('');
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const sectionIds = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
        let ev = null;
        let deferred = null;
        try {
          ev = await import('@shopify/events');
          deferred = ev.CartLinesUpdateEvent.createPromise();
          this.dispatchEvent(new ev.CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: lines.map((l) => ({ merchandiseId: l.id, quantity: l.quantity })),
            promise: deferred.promise,
          }));
        } catch (_) {
          ev = null;
        }
        try {
          const body = { items: lines };
          if (sectionIds.length) body.sections = sectionIds.join(',');
          const res = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const data = await res.json();
          const cart = await fetch(`${root}cart.js`).then((r) => r.json());
          if (!res.ok || data.status) {
            deferred?.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: true, items: cart.items, source: 'fi-shop-the-look', sourceId: this.id, itemCount: 0 } });
            this.status(data.description || data.message || 'Could not add to cart. Please try again.', true);
            return;
          }
          if (deferred && ev) {
            deferred.resolve({
              cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: { items: cart.items, source: 'fi-shop-the-look', sourceId: this.id, itemCount: lines.length, sections: data.sections, didError: false },
            });
          } else {
            document.querySelectorAll('cart-icon').forEach((c) => c.renderCartBubble?.(cart.item_count));
          }
          items.forEach((it) => {
            it.msg.textContent = 'Added';
            it.msg.classList.add('is-ok');
            it.add?.classList.add('is-done');
          });
          const label = items.length > 1 ? `Added ${items.length} pieces to your cart.` : `Added ${items[0].name} to your cart.`;
          this.status(label, false, `${root}cart`);
        } catch (err) {
          deferred?.reject(err);
          this.status('Network trouble. Please try again.', true);
        } finally {
          button.disabled = false;
          setTimeout(() => {
            items.forEach((it) => {
              it.add?.classList.remove('is-done');
              if (it.msg.classList.contains('is-ok')) { it.msg.textContent = ''; it.msg.classList.remove('is-ok'); }
            });
          }, 3500);
        }
      }

      status(text, isError, cartUrl) {
        const el = this.querySelector('[data-status]');
        if (!el) return;
        el.classList.toggle('is-error', !!isError);
        el.textContent = text;
        if (cartUrl) {
          const a = document.createElement('a');
          a.href = cartUrl;
          a.textContent = 'View cart';
          el.append(' ', a);
        }
      }

      money(cents) {
        const format = this.dataset.moneyFormat || '$' + '{' + '{amount}}';
        const fmt = (n, d, ts, ds) => {
          const fixed = (n / 100).toFixed(d);
          const [a, b] = fixed.split('.');
          return a.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (b ? ds + b : '');
        };
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
          switch (key) {
            case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
            case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
            case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
            case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
            default: return fmt(cents, 2, ',', '.');
          }
        });
      }
    }
    customElements.define('fi-shop-the-look', FiShopTheLook);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fi-wear-out"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fi-wear-card')) {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const conn = navigator.connection;
    const lite = reduced || (conn && conn.saveData);
    const io = lite
      ? null
      : new IntersectionObserver(
          (entries) => {
            entries.forEach(({ target, isIntersecting }) => {
              const v = target.querySelector('video');
              if (!v) return;
              if (isIntersecting) {
                if (!v.src) v.src = (innerWidth < 750 && v.dataset.srcM) || v.dataset.src;
                v.addEventListener('playing', () => v.classList.add('is-playing'), { once: true });
                v.play()?.catch(() => {});
              } else {
                v.pause();
              }
            });
          },
          { threshold: 0.6 }
        );
    class FiWearCard extends HTMLElement {
      connectedCallback() { io?.observe(this); }
      disconnectedCallback() { io?.unobserve(this); }
    }
    customElements.define('fi-wear-card', FiWearCard);
  }
  if (!customElements.get('fi-wear-rail')) {
    class FiWearRail extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.nav = this.querySelector('[data-nav]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track) return;
        const step = (dir) => {
          const slide = this.track.querySelector('.fi-wear__slide');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({ left: dir * ((slide?.offsetWidth || 300) + gap) });
        };
        this.prev?.addEventListener('click', () => step(-1));
        this.next?.addEventListener('click', () => step(1));
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const scrollable = max > 4;
          this.nav.toggleAttribute('hidden', !scrollable);
          this.prev.disabled = this.track.scrollLeft <= 4;
          this.next.disabled = this.track.scrollLeft >= max - 4;
        };
        this.track.addEventListener('scroll', () => requestAnimationFrame(this.update), { passive: true });
        this.ro = new ResizeObserver(this.update);
        this.ro.observe(this.track);
        this.update();
      }
      disconnectedCallback() { this.ro?.disconnect(); }
    }
    customElements.define('fi-wear-rail', FiWearRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
